var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "q-timeline-item" }, [
    _c("div", { staticClass: "q-timeline-item__tail" }),
    _vm._v(" "),
    !_vm.$slots.dot
      ? _c(
          "div",
          {
            staticClass: "q-timeline-item__node",
            class: [
              `q-timeline-item__node--${_vm.size || ""}`,
              `q-timeline-item__node--${_vm.type || ""}`,
            ],
            style: {
              backgroundColor: _vm.color,
            },
          },
          [
            _vm.icon
              ? _c("i", {
                  staticClass: "q-timeline-item__icon",
                  class: _vm.icon,
                })
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$slots.dot
      ? _c("div", { staticClass: "q-timeline-item__dot" }, [_vm._t("dot")], 2)
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "q-timeline-item__wrapper" }, [
      !_vm.hideTimestamp && _vm.placement === "top"
        ? _c("div", { staticClass: "q-timeline-item__timestamp is-top" }, [
            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "q-timeline-item__content" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      !_vm.hideTimestamp && _vm.placement === "bottom"
        ? _c("div", { staticClass: "q-timeline-item__timestamp is-bottom" }, [
            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }